<template>
  <div v-if="loaded">
    <DashboardAgent v-if="accountDetails.role === 'Agent'" />
    <Dashboard v-else />
  </div>
</template>
<script>
import { mapState } from 'vuex';
import Dashboard from './Dashboard.vue';
import DashboardAgent from './DashboardAgent.vue';

export default {
  components: {
    Dashboard,
    DashboardAgent,
  },
  data() {
    return {
      loaded: false,
    };
  },
  computed: {
    ...mapState({
      accountDetails: state => state.general.currentUserAccountDetails,
    }),
  },
  async mounted() {
    await this.$store.dispatch('general/loadCurrentUserAccountDetails');
    this.loaded = true;
  },
};
</script>
